var map = {
	"./photo-01-big.jpg": "1RMc",
	"./photo-02-big.jpg": "i6Dw",
	"./photo-03-big.jpg": "toIw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GVHz";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/photo\-0.*\-big\.jpg$
// module id = GVHz
// module chunks = 1